import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { SLIDER_POPUPS } from "App/componentsConfig";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { insertItem } from "utils";
import { ReactComponent as CloseIcon } from "assets/images/app_svg/close.svg";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";

function SliderPopup(props) {
  const history = useHistory();
  const { sPopupState, sPopupMethods } = useContext(SPopupContext);

  const popupContent = SLIDER_POPUPS[sPopupState.popup.alertName];
  let body = popupContent.body;
  const params = sPopupState.popup.params;

  if (Object.keys(params).length > 0) {
    for (let key in params.body) {
      body = insertItem(body.split(key), params.body[key], 1).join("");
    }
  }

  useEffect(() => {
    history.listen(location => {
      sPopupMethods.closePopup();
    });
  }, [history]);

  return (
    <div className={props.shadowClassess}>
      <div className="slider_popup_wrapper">
        <div
          className="slider_popup_bg_shadow"
          onClick={sPopupMethods.closePopup}
        />

        <div className="slider_popup__inner">
          <div
            className={[
              props.componentClassess,
              SLIDER_POPUPS[sPopupState.popup.alertName].class
            ].join(" ")}
          >
            <div className="popup_close" onClick={sPopupMethods.closePopup}>
              <Tooltip {...TOOLTIPS.slidingPopup.close}>
                {/* <div className="icon"> */}
                <CloseIcon />
                {/* </div> */}
              </Tooltip>
            </div>

            <div className="popup_header">
              <div className="sub_title">{popupContent.title}</div>
            </div>

            <div className="popup_body">
              {typeof body === "string" ? (
                <p dangerouslySetInnerHTML={{ __html: body }} />
              ) : (
                React.createElement(body)
              )}
            </div>

            {popupContent.type && (
              <div className="popup_footer">
                {SLIDER_POPUPS[sPopupState.popup.alertName].footer ? (
                  <div className="irpopup_msg">
                    <p className="semi_strong">
                      {SLIDER_POPUPS[sPopupState.popup.alertName].footer}
                    </p>
                  </div>
                ) : null}
                {SLIDER_POPUPS[sPopupState.popup.alertName].leftFooter ? (
                  <div
                    className={[
                      "new_folder_",
                      sPopupState.popup.params.disableLeftFooter
                        ? "disable"
                        : "btn"
                    ].join("")}
                    onClick={
                      sPopupState.popup.params.disableLeftFooter
                        ? undefined
                        : sPopupState.popup.params.createFolder
                    }
                  >
                    <p>
                      {SLIDER_POPUPS[sPopupState.popup.alertName].leftFooter}
                    </p>
                  </div>
                ) : null}
                <div className="popup_footer__btns">
                  {!popupContent.dontShowCancel && (
                    <div
                      className="slider_btn popup_btn_cancel"
                      onClick={
                        sPopupState.popup.params.cancel
                          ? sPopupState.popup.params.secondExecute
                          : sPopupMethods.closePopup
                      }
                    >
                      {popupContent.secondType
                        ? popupContent.secondType
                        : "Cancel"}
                    </div>
                  )}
                  <div
                    className={[
                      "slider_btn",
                      sPopupState.popup.params.disable
                        ? "btn_disable"
                        : "btn_primary",
                      popupContent.alertType === "WARN" ? "btn-danger" : ""
                    ].join(" ")}
                    onClick={
                      sPopupState.popup.params.disable
                        ? undefined
                        : sPopupState.popup.params.execute
                    }
                  >
                    {popupContent.type}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SliderPopup;
